import React, { useState } from 'react';
import { Table } from 'antd';
import styles from './index.scss';

import { columnParser } from './utils';

const WatchAndWhitelistTable = (props) => {
  const {
    tableData,
    saveRunInstanceConfigToStore,
    saveMatchingConfigToStore,
    selectedRowKeysDataFromProps,
    component,
    GS,
    hasPagination,
    hasRowSelection,
    showDrawer,
    hasExecuteAccessToSelect = false,
    pageType
  } = props;

  const { isLoading = false } = tableData || {};
  const [selectedRowKeys, setSelectedRowKeys] = useState(
    selectedRowKeysDataFromProps
  );

  const [pageSize, setPagesize] = useState(5);
  // onChange function for each row checkbox selection
  const onSelectChange = (userSelectedRowKeys) => {
    setSelectedRowKeys(userSelectedRowKeys);
    if (saveRunInstanceConfigToStore) {
      let validationPassed = userSelectedRowKeys.length ? true : false;
      const componentKey =
        component == 'SelectWatchList' ? 'watchListData' : 'whiteListData';
      saveRunInstanceConfigToStore(
        componentKey,
        userSelectedRowKeys,
        validationPassed
      );
    }

    if (saveMatchingConfigToStore) {
      let validationPassed = userSelectedRowKeys.length ? true : false;
      const componentKey =
        component == 'SelectWatchList' ? 'watchListData' : 'whiteListData';
      saveMatchingConfigToStore(
        componentKey,
        userSelectedRowKeys,
        validationPassed
      );
    }
  };

  const parseSelectedItemsStringToIndex = () => {
    const selectedKeysIndex = [];
    if (
      tableData.data &&
      Object.keys(tableData.data).length > 0 &&
      Array.isArray(selectedRowKeysDataFromProps) &&
      selectedRowKeysDataFromProps.length > 0
    ) {
      Object.keys(tableData.data).forEach((tableItemKey, tableItemKeyIndex) => {
        selectedRowKeysDataFromProps.forEach(
          (selectedRowKeysDataFromPropsItem) => {
            if (
              tableData.data[tableItemKey] &&
              selectedRowKeysDataFromPropsItem &&
              selectedRowKeysDataFromPropsItem ===
                tableData.data[tableItemKey].id
            ) {
              selectedKeysIndex.push(tableItemKeyIndex + 1);
            }
          }
        );
      });
    }

    return selectedKeysIndex;
  };

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: parseSelectedItemsStringToIndex(),
    onChange: onSelectChange,
    hideSelectAll: true,
    getCheckboxProps: () => ({
      disabled: !hasExecuteAccessToSelect || pageType === 'view'
    })
  };

  //Table Column data
  const columns = columnParser(GS && GS.widgetConfig, component, showDrawer);

  //Table Data
  const data = [];

  // To Modify Dates in Table and add Key to the Table Component
  if (tableData?.data && Array.isArray(tableData.data)) {
    tableData.data.forEach((item) => {
      data.push(item);
    });
    for (let obj of data) {
      obj['key'] = data.findIndex((v) => v.id == obj.id) + 1;
    }
  }
  const showTotal = () => `${data?.length} Records`;

  const onPaginationChange = (page, newPageSize) => setPagesize(newPageSize);

  return (
    <div className={styles.table_wrapper}>
      <Table
        rowSelection={
          hasRowSelection && {
            ...rowSelection
          }
        }
        columns={columns}
        dataSource={data}
        loading={isLoading}
        pagination={
          hasPagination && {
            pageSize: pageSize,
            showTotal: showTotal,
            showSizeChanger: true,
            showLessItems: true,
            pageSizeOptions: [5, 10, 25, 50, 100],
            onChange: onPaginationChange
          }
        }
        scroll={hasPagination && { y: 240 }}
      />
    </div>
  );
};

export default WatchAndWhitelistTable;
